"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class TargetGradesServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async saveTargetGrades(targetGrades) {
        const url = this.url + '/api/grades';
        const options = { method: 'POST', body: JSON.stringify({ targetGrades }) };
        const expectedResponses = [201];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async fetchTargetGrades() {
        const url = this.url + '/api/grades';
        const options = { method: 'GET' };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async saveTargetGradeForSubjectAgeGroup({ subjectId, ageGroupId, grade }) {
        const url = `${this.url}/api/grade/subjectId/${subjectId}/ageGroupId/${ageGroupId}`;
        const options = { method: 'POST', body: JSON.stringify({ grade }) };
        const expectedResponses = [201];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async fetchTargetGradeForSubjectAgeGroup({ subjectId, ageGroupId }) {
        const url = `${this.url}/api/grade/subjectId/${subjectId}/ageGroupId/${ageGroupId}`;
        const options = { method: 'GET' };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async updateTargetGradeForSubjectAgeGroup({ subjectId, ageGroupId, grade }) {
        const url = `${this.url}/api/grade/subjectId/${subjectId}/ageGroupId/${ageGroupId}`;
        const options = { method: 'PATCH', body: JSON.stringify({ grade }) };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
}
exports.default = TargetGradesServiceClient;
//# sourceMappingURL=TargetGradesServiceClient.js.map